module.exports = __webpack_public_path__ + "img/V51.2d88bb30.jpg";